module.exports = __webpack_public_path__ + "static/media/Icon_Flooring.609cbd4b.png";